
import Vue from "vue";
import api from "@/services/dataService";
import notification from "@/services/notificationService";
import store from "@/store";
import { User, userRoles, Vehicle } from "@/shared/models";

export default Vue.extend({
  name: "UserRightSidebar",
  props: {
    userId: String
  },
  data() {
    return {
      userRoles,
      editUserToggle: false,
      archiveUserToggle: false,
      editUserDetail: {
        salutation: undefined,
        firstName: undefined,
        lastName: undefined,
        roles: undefined as undefined | string[] | string,
        vehicles: undefined as undefined | string[]
      }
    };
  },
  computed: {
    selectedTenant() {
      return store.state.selectedTenant;
    },
    userDetail() {
      return store.state.userDetail;
    },
    vehicles() {
      return store.state.vehicles;
    }
  },
  created() {
    this.getUserDetail();
    this.getVehicles();
  },
  watch: {
    userId: function () {
      if (!this.userId) {
        this.$store.dispatch("setUserDetail", undefined);
      } else {
        // watching userId value to update userDetail on value change
        this.getUserDetail();
      }
    },
    userDetail: function (newValue) {
      if (newValue) {
        this.editUserDetail = {
          salutation: newValue.salutation,
          firstName: newValue.firstName,
          lastName: newValue.lastName,
          roles: newValue.roles[0],
          vehicles: newValue.vehicles.map((vehicle: Vehicle) => {
            return vehicle.id;
          })
        };
      }
    }
  },
  methods: {
    getUserDetail() {
      if (this.$route.query.id) {
        this.$store.dispatch("getUserDetail", {
          selectedTenant: this.selectedTenant,
          userId: this.$route.query.id
        });
        this.editUserToggle = false;
      }
    },
    async updateUserDetail() {
      const request = {
        salutation: this.editUserDetail.salutation,
        firstName: this.editUserDetail.firstName,
        lastName: this.editUserDetail.lastName,
        roles: [this.editUserDetail.roles],
        vehicles: this.editUserDetail.vehicles?.map((id) => {
          return { id: id };
        })
      };
      await this.$store
        .dispatch("updateUserDetail", {
          userId: this.$route.query.id,
          userDetail: request
        })
        .then(() => {
          this.editUserToggle = false;
          this.getUserDetail();
          this.$emit("user-update");
        });
    },
    async archiveUser(flag: boolean) {
      await this.$store
        .dispatch("updateUserDetail", {
          userId: this.$route.query.id,
          userDetail: { archived: flag }
        })
        .then(() => {
          this.archiveUserToggle = false;
          this.$emit("user-update");
          this.$emit("sidebar-closed");
        });
    },
    getVehicles() {
      this.$store.dispatch("getVehicles", {
        selectedTenant: this.selectedTenant
      });
    }
  }
});
